import { useGetMyPushInfosUnreadCountQuery } from "src/graphql-next/generated/queries";
import type { GetMyPushInfosUnreadCountQuery } from "src/graphql-next/generated/types";
import { useCurrentAccount } from "src/hooks";
import { decodeBase64UUID } from "src/utils";

type Data = { count: number };

export const useGetUnreadNotificationsCount = () => {
  const account = useCurrentAccount();
  const { accountId, customerId } = decodeBase64UUID(account.uuid);
  return useGetMyPushInfosUnreadCountQuery<Data>(
    { accountId, customerId },
    {
      select: (data: GetMyPushInfosUnreadCountQuery) => ({
        count: data.pushInfosUnreadCount,
      }),
    }
  );
};
